<section class="section p-0 my-2 has-text-centered">
    <h5 class="">{{'PROFILE.DELETE_TITLE' | translate}}</h5>
    <hr>
    <p class="text-size-14 pt-3" style="color: #616a76;">{{displayInfo}}</p>
    <div class="columns is-flex is-justify-content-center is-flex-wrap-wrap pt-5">
            <div class="button btn_cancel m-2 has-text-weight-semibold" (click)="clickClose()">{{'PROFILE.KEEP_VEHCILE' | translate}}</div>
            <div class="button is-success m-2 has-text-weight-semibold" (click)="deleteVehcile()">{{'PROFILE.REMOVE_VEHCILE' | translate}}</div>
    </div>
</section>
